export interface UpdateOrganizationChecklistDto {
    name: string;
    tasks: string[];
}
